<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="8">
        <v-card class="ma-4 pa-2">
          <!-- Title -->
          <v-card-title>{{ t('Registro') }}</v-card-title>

          <!-- Content -->
          <v-card-text>
            <!-- Loading Spinner/Message -->
            <HelperCarregant v-if="loading" :missatge="t('Creando') + ' ' + t('usuario')" />

            <!-- Registration Form or Success Message -->
            <template v-if="!loading">
              <!-- Success message if registration is complete -->
              <div v-if="registrationComplete">
                <!-- You can style this however you like, for example using v-alert or a plain div -->
                <v-alert type="success" border="left" prominent>
                  {{ t('Se_ha_enviado_un_correo_de_verificacion') }}<br />
                  {{ t('Por_favor_revisa_tu_email_para_continuar') }}
                </v-alert>
              </div>
              <!-- Show the form if registration is not complete -->
              <form v-else @submit.prevent="register">
                <v-text-field :label="t('Email')" v-model="email" required type="email"></v-text-field>

                <v-text-field v-model="first_name" :label="t('Nombre')" required></v-text-field>

                <v-text-field v-model="last_name" :label="t('Apellidos')" required></v-text-field>

                <v-text-field :label="t('Contraseña')" v-model="password1" required type="password"></v-text-field>

                <v-text-field :label="t('Vuelve_a_escribir_la_c')" v-model="password2" required
                  type="password"></v-text-field>

                <v-checkbox :label="t('He_leído_y_acepto')" v-model="consent" required></v-checkbox>

                <v-btn class="mt-5" type="submit" color="primary" :disabled="loading">
                  {{ t('Registrarse') }}
                </v-btn>
              </form>
            </template>
          </v-card-text>

          <!-- Links / Actions -->
          <v-card-actions class="justify-center">
            <span>{{ t('Ya_tienes_una_cuenta') }}</span>
            <v-btn text small color="primary" :disabled="loading" @click="router.push('/login')">
              {{ t('Iniciar_sesión') }}
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useUiStore   } from '@/stores/ui';
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { axios } from '../axios'
import HelperCarregant from './HelperCarregant.vue'

// i18n and Vuex
const { t } = useI18n()
const uiStore   = useUiStore();      // snackbar
const router = useRouter()

// Reactive references
const first_name = ref('')
const last_name = ref('')
const email = ref('')
const password1 = ref('')
const password2 = ref('')
const consent = ref(false)
const loading = ref(false)
const snackbarText = ref('')
const registrationComplete = ref(false)


// Registration handler
async function register() {
  loading.value = true
  try {
    const response = await axios.post('dj-rest-auth/registration/', {
      first_name: first_name.value,
      last_name: last_name.value,
      email: email.value,
      password1: password1.value,
      password2: password2.value,
    })

    // If success response includes "detail", show success message (no redirect)
    if (response.data.detail) {
      snackbarText.value = response.data.detail // e.g. "Se ha enviado un correo de verificación."
      uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' })
      registrationComplete.value = true
    }
  } catch (error) {
    let errorMessages = []
    if (error.response) {
      // Check if response data is an array (e.g., ["This email is already in use."])
      if (Array.isArray(error.response.data)) {
        errorMessages = error.response.data
      }
      // Check if the error message is in the 'detail' attribute
      else if (error.response.data.detail) {
        errorMessages.push(error.response.data.detail)
      }
      // Otherwise, handle field-specific errors (which are usually objects)
      else {
        for (let field in error.response.data) {
          let errorsForField = error.response.data[field]
          if (Array.isArray(errorsForField)) {
            errorMessages.push(...errorsForField)
          } else {
            errorMessages.push(errorsForField)
          }
        }
      }
    } else {
      // No server response or other error
      errorMessages.push('An unexpected error occurred.')
    }
    snackbarText.value = errorMessages.join(' ');
    uiStore.triggerSnackbar( { message: snackbarText.value, color: 'error' });
  } finally {
    loading.value = false
  }
}
</script>
